package uz.ferro.shop.ui.table

import react.ReactNode
import web.cssom.TextAlign

data class CellItem(
    val title: String? = null,
    val content: ReactNode? = null,
    val textAlign: TextAlign? = null
)
